// The docs screen keeps the last opened article so /edit-docs reopens it. A
// review URL points at a proposal instead, so the fallback has to stay off or
// the breadcrumb and nav selection show an unrelated article.
export function resolveDocsArticleId({
	paramsId,
	isReviewMode,
	lastOpenedArticleId,
	isMobile = false,
}: {
	paramsId: string
	isReviewMode: boolean
	lastOpenedArticleId: string
	isMobile?: boolean
}): string {
	if (paramsId) return paramsId
	if (isReviewMode) return ""
	// A phone shows one pane at a time, so restoring the last article at
	// /edit-docs would reopen the detail the back button just closed.
	return isMobile ? "" : lastOpenedArticleId
}
